import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import {Table, Image, Button, Modal} from 'react-bootstrap';
import styled from 'styled-components';

import bestPresenter1 from '../../assets/images/contents/bestPresenter1.jpg';
import bestPresenter2 from '../../assets/images/contents/bestPresenter2.jpg';
import bestPresenter3 from '../../assets/images/contents/bestPresenter3.jpg';
import bestPresenter4 from '../../assets/images/contents/bestPresenter4.jpg';

import bestPaper1 from '../../assets/images/contents/bestPaper1.jpg';
import bestPaper2 from '../../assets/images/contents/bestPaper2.jpg';
import bestPaper3 from '../../assets/images/contents/bestPaper3.jpg';
import bestPaper4 from '../../assets/images/contents/bestPaper4.jpg';
import bestPaper5 from '../../assets/images/contents/bestPaper5.jpg';
import bestPaper6 from '../../assets/images/contents/bestPaper6.jpg';
import bestPaper7 from '../../assets/images/contents/bestPaper7.jpg';
import bestPaper8 from '../../assets/images/contents/bestPaper8.jpg';
import bestPaper9 from '../../assets/images/contents/bestPaper9.jpg';
import bestPaper10 from '../../assets/images/contents/bestPaper10.jpg';

const Styles = styled.div`
  .img {
  width: 600px;
  height: auto;
  /* ease | ease-in | ease-out | linear */
  transition: transform ease-in-out 0.3s;
}
.img:hover {
  transform: scale(1.2);
}
`;

export function BestPaper() {
  const [fullscreen, setFullscreen] = useState(true);
  const [lgShow1, setLgShow1] = useState(false);
  const [lgShow2, setLgShow2] = useState(false);
  const [lgShow3, setLgShow3] = useState(false);
  const [lgShow4, setLgShow4] = useState(false);

  const [lgShowBestPaper1, setlgShowBestPaper1] = useState(false);
  const [lgShowBestPaper2, setlgShowBestPaper2] = useState(false);
  const [lgShowBestPaper3, setlgShowBestPaper3] = useState(false);
  const [lgShowBestPaper4, setlgShowBestPaper4] = useState(false);
  const [lgShowBestPaper5, setlgShowBestPaper5] = useState(false);
  const [lgShowBestPaper6, setlgShowBestPaper6] = useState(false);
  const [lgShowBestPaper7, setlgShowBestPaper7] = useState(false);
  const [lgShowBestPaper8, setlgShowBestPaper8] = useState(false);
  const [lgShowBestPaper9, setlgShowBestPaper9] = useState(false);
  const [lgShowBestPaper10, setlgShowBestPaper10] = useState(false);
  
  return (
    <Styles>
      <Helmet>
        <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Best Paper</title>
      </Helmet>
      <nav aria-label="breadcrumb">
       <ol class="breadcrumb">
         <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
         <li class="breadcrumb-item"><a href="/">Information</a></li>
         <li class="breadcrumb-item active" aria-current="page">Best Paper Awards</li>
       </ol>
     </nav>
     <h2>Best Paper</h2>
     <p><i>To PC users, you can view the abstract clearly by right-clicking and selecting "Open image in new tab".</i></p>
     <p><b>List of Best Presenter Awards 2021</b></p>

      <Table>
      <thead>
        <tr>
          <th></th>
          <th>Track</th>
          <th>Authors</th>
          <th>Title of Paper</th>
          <th>Abstracts</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Data Analytics and Technologies</td>
          <td>Yih Hern Kong</td>
          <td>Time Series Forecasting Using a Hybrid Prophet and Long Short-Term Memory Model</td>
          <td> 
            <Button onClick={() => setLgShow1(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShow1}
              onHide={() => setLgShow1(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #1 Best Presenter Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPresenter1} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>AI Techniques and Applications</td>
          <td>Adila Sekarratri Dwi Praytino</td>
          <td>A Smart Predictive Maintenance Scheme for Classifying Diagnostic and Prognostic Statuses</td>
          <td>
          <Button onClick={() => setLgShow2(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShow2}
              onHide={() => setLgShow2(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #2 Best Presenter Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPresenter2} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>Data Analytics and Technologies</td>
          <td>Gee Kok Tong</td>
          <td>Construction of Optimal Stock Market Portfolios Using Outlier Detection Algorithm</td>
          <td>
          <Button onClick={() => setLgShow3(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShow3}
              onHide={() => setLgShow3(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #3 Best Presenter Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPresenter3} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>Machine and Statistical Learning</td>
          <td>Ajiwasesa Harumeka</td>
          <td>Entropy-Based Fuzzy Weighted Logistic Regression for Classifying Imbalanced Data</td>
          <td>
          <Button onClick={() => setLgShow4(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShow4}
              onHide={() => setLgShow4(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #4 Best Presenter Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPresenter4} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
      </tbody>
    </Table>

<br/>
    <p><b>List of Best Paper Awards 2021</b></p>
    <Table>
      <thead>
        <tr>
          <th></th>
          <th>Authors</th>
          <th colSpan="2">Title of Paper</th>
          <th>Abstracts</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Achmad Choiruddin, Tabita Yuni Susanto, Rahma Metrikasari</td>
          <td colSpan="2">Two-Step Estimation for Modeling the Earthquake Occurrences in Sumatra by Neyman–Scott Cox Point Processes</td>
          <td> 
            <Button onClick={() => setlgShowBestPaper1(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper1}
              onHide={() => setlgShowBestPaper1(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #1 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper1} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>Yih Hern Kong, Khai Yin Lim, Wan Yoke Chin</td>
          <td colSpan="2">Time Series Forecasting Using a Hybrid Prophet and Long Short-Term Memory Model</td>
          <td>
          <Button onClick={() => setlgShowBestPaper2(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper2}
              onHide={() => setlgShowBestPaper2(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #2 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper2} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>Selvi Mardalena, Purhadi, Jerry Dwi Trijoyo Purnomo</td>
          <td colSpan="2">A Modified Inverse Gaussian Poisson Regression with an Exposure Variable to Model Infant Mortality</td>
          <td>
          <Button onClick={() => setlgShowBestPaper3(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper3}
              onHide={() => setlgShowBestPaper3(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #3 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper3} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>Ahmad Husain, Achmad Choiruddin</td>
          <td colSpan="2">Poisson and Logistic Regressions for Inhomogeneous Multivariate Point Processes: A Case Study in the Barro Colorado Island Plot</td>
          <td>
          <Button onClick={() => setlgShowBestPaper4(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper4}
              onHide={() => setlgShowBestPaper4(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #4 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper4} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>5</td>
          <td>Prilyandari Dina Saputri, Arin Berliana Angrenani, Dinda Galuh Guminta, Fonda Leviany, Ika Nur Laily Fitriana, Santi Puteri Rahayu, Hidayatul Khusna</td>
          <td colSpan="2">Multivariate Analysis to Evaluate the Impact of COVID-19 on the Hotel Industry in Indonesia</td>
          <td>
          <Button onClick={() => setlgShowBestPaper5(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper5}
              onHide={() => setlgShowBestPaper5(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #5 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper5} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>6</td>
          <td>Hendri Prabowo, Dedy Dwi Prastyo, Setiawan</td>
          <td colSpan="2">Hybrid of Time Series Regression, Multivariate Generalized Space-Time Autoregressive, and Machine Learning for Forecasting Air Pollution</td>
          <td>
          <Button onClick={() => setlgShowBestPaper6(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper6}
              onHide={() => setlgShowBestPaper6(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #6 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper6} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>7</td>
          <td>Choon Yi Lee, Siew Khew Koh, Min Cherng Lee, Wei Yeing Pan</td>
          <td colSpan="2">Application of Machine Learning in Credit Risk Scorecard</td>
          <td>
          <Button onClick={() => setlgShowBestPaper7(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper7}
              onHide={() => setlgShowBestPaper7(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #7 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper7} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>8</td>
          <td>Putu Desiana Wulaning Ayu, Sri Hartati, Aina Musdholifah, Detty S. Nurdiati</td>
          <td colSpan="2">Amniotic Fluids Classification Using Combination of Rules-Based and Random Forest Algorithm</td>
          <td>
          <Button onClick={() => setlgShowBestPaper8(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper8}
              onHide={() => setlgShowBestPaper8(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #8 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper8} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>9</td>
          <td>Muhammad Syamil Ali, Marina Yusoff</td>
          <td colSpan="2">Comparison Performance of Long Short-Term Memory and Convolution Neural Network Variants on Online Learning Tweet Sentiment Analysis</td>
          <td>
          <Button onClick={() => setlgShowBestPaper9(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper9}
              onHide={() => setlgShowBestPaper9(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #9 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper9} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
        <tr>
          <td>10</td>
          <td>Shahrizan Jamaludin, Nasharuddin Zainal, W. Mimi Diyana W. Zaki, Ahmad Faisal Mohamad Ayob</td>
          <td colSpan="2">Iris Segmentation Based on an Adaptive Initial Contour and Partly-Normalization</td>
          <td>
          <Button onClick={() => setlgShowBestPaper10(true)}>View</Button>
            <Modal
              centered='true'
              fullscreen={fullscreen}
              size="lg"
              show={lgShowBestPaper10}
              onHide={() => setlgShowBestPaper10(false)}
              dialogClassName="modal-90w"
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  #10 Best Paper Award
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Image class="img" src={bestPaper10} fluid='true' />
              </Modal.Body>
            </Modal>
          </td>
        </tr>
      </tbody>
    </Table>
    </Styles>
  );
}

// export const BestPaper = () => (
//   <>
//     <Helmet>
//       <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Best Paper</title>
//     </Helmet>
//      <nav aria-label="breadcrumb">
//       <ol class="breadcrumb">
//         <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
//         <li class="breadcrumb-item"><a href="/">Information</a></li>
//         <li class="breadcrumb-item active" aria-current="page">Best Paper Awards</li>
//       </ol>
//     </nav>
//     <h2>Best Paper</h2>
//     <p>List of Best Presenter Awards 2021</p>

    // <Table>
    //   <thead>
    //     <tr>
    //       <th></th>
    //       <th>Track</th>
    //       <th>Authors</th>
    //       <th>Title of Paper</th>
    //       <th>Abstracts</th>
    //     </tr>
    //   </thead>
    //   <tbody>
    //     <tr>
    //       <td>1</td>
    //       <td>Data Analytics and Technologies</td>
    //       <td>Yih Hern Kong</td>
    //       <td>Time Series Forecasting Using a Hybrid Prophet and Long Short-Term Memory Model</td>
    //       <td><a href={bestPresenter1} target="_blank" rel="noreferrer">View</a><Image thumbnail="false" src={bestPresenter1} fluid="false" /></td>
    //     </tr>
    //     <tr>
    //       <td>2</td>
    //       <td>AI Techniques and Applications</td>
    //       <td>Adila Sekarratri Dwi Praytino</td>
    //       <td>A Smart Predictive Maintenance Scheme for Classifying Diagnostic and Prognostic Statuses</td>
    //       <td>View</td>
    //     </tr>
    //     <tr>
    //       <td>3</td>
    //       <td>Data Analytics and Technologies</td>
    //       <td>Gee Kok Tong</td>
    //       <td>Construction of Optimal Stock Market Portfolios Using Outlier Detection Algorithm</td>
    //       <td>View</td>
    //     </tr>
    //     <tr>
    //       <td>4</td>
    //       <td>Machine and Statistical Learning</td>
    //       <td>Ajiwasesa Harumeka</td>
    //       <td>Entropy-Based Fuzzy Weighted Logistic Regression for Classifying Imbalanced Data</td>
    //       <td>View</td>
    //     </tr>
    //   </tbody>
    // </Table>

    // <p>List of Best Paper Awards 2021</p>
//   </>
// )